export default __webpack_public_path__ + "95958f349e15b331cb1e6b27c7d76c3e.svg";